import { render, staticRenderFns } from "./BeneficiosGaleria.vue?vue&type=template&id=cdbc40f0&scoped=true&lang=pug"
import script from "./BeneficiosGaleria.vue?vue&type=script&lang=js"
export * from "./BeneficiosGaleria.vue?vue&type=script&lang=js"
import style0 from "./BeneficiosGaleria.styl?vue&type=style&index=0&id=cdbc40f0&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbc40f0",
  null
  
)

export default component.exports